import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
const NAMES = ['María', 'Sofía', 'Carolina', 'Valentina', 'Luciana', 'Marcela', 'Laura', 'Ana', 'Florencia', 'Camila', 'Paula', 'Romina', 'Daniela', 'Agustina', 'Julieta', 'Natalia', 'Gabriela', 'Celeste', 'Micaela', 'Belén'];
const PROVINCES = ['Buenos Aires', 'CABA', 'Córdoba', 'Santa Fe', 'Mendoza', 'Tucumán', 'Salta', 'Entre Ríos', 'Misiones', 'Chaco', 'Corrientes', 'Santiago del Estero', 'San Juan', 'Jujuy', 'Río Negro', 'Neuquén', 'Formosa', 'Chubut', 'San Luis', 'Catamarca', 'La Rioja', 'La Pampa', 'Santa Cruz', 'Tierra del Fuego'];
const OFFERS = ['GAP 360 — Sistema Completo', 'GAP 360 Rose Gold Edition™'];
export const PurchasePopup = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [currentData, setCurrentData] = useState({
    name: '',
    province: '',
    offer: ''
  });
  const getRandomItem = (arr: string[]) => arr[Math.floor(Math.random() * arr.length)];
  const getRandomDelay = () => Math.floor(Math.random() * (80000 - 45000 + 1) + 45000);
  useEffect(() => {
    let showTimeout: NodeJS.Timeout;
    let hideTimeout: NodeJS.Timeout;
    const scheduleNextPopup = () => {
      const delay = getRandomDelay();
      showTimeout = setTimeout(() => {
        setCurrentData({
          name: getRandomItem(NAMES),
          province: getRandomItem(PROVINCES),
          offer: getRandomItem(OFFERS)
        });
        setIsVisible(true);
        hideTimeout = setTimeout(() => {
          setIsVisible(false);
          scheduleNextPopup();
        }, 4000);
      }, delay);
    };
    scheduleNextPopup();
    return () => {
      clearTimeout(showTimeout);
      clearTimeout(hideTimeout);
    };
  }, []);
  const isRoseGold = currentData.offer.includes('Rose Gold');
  return <AnimatePresence data-id="element-246">
      {isVisible && <motion.div initial={{
      opacity: 0,
      x: -50,
      y: 20
    }} animate={{
      opacity: 1,
      x: 0,
      y: 0
    }} exit={{
      opacity: 0,
      x: -50,
      transition: {
        duration: 0.3
      }
    }} className="fixed bottom-4 left-4 right-4 md:right-auto md:left-4 z-50 md:max-w-[320px] bg-white rounded-xl shadow-2xl border border-gray-200 p-4 flex items-start gap-3" data-id="element-247">
          <div className="relative mt-1" data-id="element-248">
            <div className="w-2.5 h-2.5 bg-green-500 rounded-full" data-id="element-249"></div>
            <div className="w-2.5 h-2.5 bg-green-500 rounded-full absolute top-0 left-0 animate-ping opacity-75" data-id="element-250"></div>
          </div>
          <div className="flex-1 text-sm leading-tight" data-id="element-251">
            <p className="text-gray-600 mb-1" data-id="element-252">
              🛒{' '}
              <span className="font-bold text-charcoal" data-id="element-253">
                {currentData.name}
              </span>{' '}
              de <span className="text-gray-500" data-id="element-254">{currentData.province}</span>,
              Argentina acaba de adquirir
            </p>
            <p className={`font-bold ${isRoseGold ? 'text-gold' : 'text-coral'}`} data-id="element-255">
              {currentData.offer}
            </p>
          </div>
        </motion.div>}
    </AnimatePresence>;
};